import { render, staticRenderFns } from "./ConfirmModal.vue?vue&type=template&id=96fe9fb8&scoped=true&lang=pug&"
import script from "./ConfirmModal.vue?vue&type=script&lang=ts&"
export * from "./ConfirmModal.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmModal.vue?vue&type=style&index=0&id=96fe9fb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96fe9fb8",
  null
  
)

export default component.exports